<script lang="ts">
  import { Button, Col, Form, FormGroup, Input, Row } from "sveltestrap";
  import { href, Submit } from "../../../../utils/Constant/Constant";
</script>
<Row>
    <Form class="theme-form row">
      <Col xs="6" class="p-r-0">
        <FormGroup>
            <Input type="text" placeholder="First Name"/>
        </FormGroup>
      </Col>
      <Col xs="6">
        <FormGroup>
            <Input type="text" placeholder="Last name"/>
        </FormGroup>
      </Col>
      <Col xs="6" class="p-r-0">
        <FormGroup>
            <Input type="text" placeholder="Pincode"/>
        </FormGroup>
      </Col>
      <Col xs="6">
        <FormGroup>
            <Input type="number" placeholder="Enter mobile number"/>
        </FormGroup>
      </Col>
      <Col xs="6" class="p-r-0">
        <FormGroup>
            <Input type="text" placeholder="State"/>
        </FormGroup>
      </Col>
      <Col xs="6" >
        <FormGroup>
            <Input type="text" placeholder="City"/>
        </FormGroup>
      </Col>
      <Col xs="12">
        <FormGroup>
            <textarea class="form-control" rows="3" placeholder="Address"></textarea>
        </FormGroup>
      </Col>
      <Col xs="12">
        <Button color="primary" class="btn-block" href={href}>{Submit}</Button>
      </Col>
    </Form>
</Row>